// Fetcher fetch wrapper with retry

// function updateOptions(options: any, accessToken: string) {
// 	const update = { ...options }
// 	update.headers = {
// 		...update.headers,
// 		'exzeoiq-access-key': accessToken,
// 	}
// 	return update
// }

// export function fetcher(url: string | URL, accessToken: string, options: any) {
// 	return fetch(url, updateOptions(options, accessToken))
// }

export function fetchJson(url: string | URL, body: string | FormData | undefined, credentials: 'include' | 'omit' | 'same-origin', headers: Record<string, string>, options: RequestInit) {
	return fetch(url, {
		method: 'POST',
		body,
		credentials,
		headers,
		...options,
	})
}

export interface FetcherOptions {
	timeoutMs?: number
	retry?: number
	credentials?: 'include' | 'omit' | 'same-origin'
	headers?: Record<string, string>
	body?: string | FormData | undefined
	method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
}

export async function oldFetcher<T = unknown>(
	url: string | URL,
	{
		timeoutMs = 60000,
		retry = 5,
		credentials = 'omit',
		headers,
		body,
		method = 'GET',
	}: FetcherOptions = {},
): Promise<T> {
	let attempt = 0
	while (true) {
		attempt++
		const controller = new AbortController()
		const timer: ReturnType<typeof setTimeout> = setTimeout(() => controller.abort(), timeoutMs)
		try {
			// Ensure the fetch uses the controller's signal so timeout actually aborts the request.
			const resp = await fetch(url, {
				method,
				body,
				credentials,
				headers,
				signal: controller.signal,
			})
			clearTimeout(timer)
			if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
			const data = (await resp.json()) as T
			return data
		} catch (err) {
			clearTimeout(timer)
			// If aborted due to timeout, treat like a retryable error until attempts exhausted
			if (attempt > retry) throw err
			await new Promise<void>((r) => setTimeout(r, 250 * attempt))
		}
	}
}

export async function fetcher(
	url: string | URL,
	{
		timeoutMs = 60000,
		retry = 5,
		credentials = 'omit',
		headers,
		body,
		method = 'GET',
	}: FetcherOptions = {},
): Promise<Response> {
	let attempt = 0
	while (true) {
		attempt++
		const controller = new AbortController()
		const timer: ReturnType<typeof setTimeout> = setTimeout(
			() => controller.abort(),
			timeoutMs,
		)
		try {
			const resp = await fetch(url, {
				method,
				body,
				credentials,
				headers,
				signal: controller.signal,
			})
			clearTimeout(timer)
			return resp
		} catch (err) {
			clearTimeout(timer)
			if (attempt > retry) throw err
			await new Promise<void>((r) => setTimeout(r, 250 * attempt))
		}
	}
}
